

function removePositionAndDescription(obj) {
    if (Array.isArray(obj)) {
        return obj.map(removePositionAndDescription);
    } else if (obj && typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
            if (key === 'position' || key === 'description') continue;
            newObj[key] = removePositionAndDescription(obj[key]);
        }
        return newObj;
    }
    return obj;
}

export async function hashDiagram(diagram) {
    const cleanedDiagram = removePositionAndDescription(diagram);
    const str = JSON.stringify(cleanedDiagram);
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    // Convert buffer to hex string
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

export async function upsertPolicy(policy){
    return
}

export async function undeployPolicy(params) {
    return
}

export async function removePolicy(params) {
    return
}